// import LightBoxLatestExample from "components/common/LightBoxLatestExample";
// import SubtleBadge from "components/common/SubtleBadge";
// import { useFetchCategoryVariants } from "hooks/useFetchCategoryVariants";
// import { useFetchVariants } from "hooks/useFetchDetailVariants";
// import { useEffect, useMemo } from "react";
// import {
//   Button,
//   Card,
//   Col,
//   Form,
//   Row,
//   Table
// } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import { useLocation, useNavigate } from "react-router-dom";
// import Select from "react-select";

// const Variants = () => {
//   const {
//     register,
//     getValues,
//     control,
//     watch,
//     setValue,
//     formState: { errors },
//   } = useFormContext();

//   const { pathname } = useLocation();
//   const navigate = useNavigate();

//   const categoryId = watch("categoryId");

//   const { data: variantsData, isLoading: variantsLoading } = useFetchVariants();

//   const { data: categoryVariantsData, isLoading: categoryVariantsLoading } =
//     useFetchCategoryVariants();

//   const filteredCategoryVariants = useMemo(() => {
//     if (!categoryVariantsData || !categoryId) return [];
//     return categoryVariantsData?.data?.data?.filter(
//       (set) => set.categoryId === categoryId
//     );
//   }, [categoryVariantsData, categoryId]);

//   const variantsIds = useMemo(() => {
//     return filteredCategoryVariants?.flatMap((set) =>
//       set.options.map((fs) => fs.variantId)
//     );
//   }, [filteredCategoryVariants]);

//   const filteredVariantsOption = useMemo(() => {
//     if (!variantsData || variantsIds.length === 0) return [];
//     return variantsData?.data?.data?.filter((variant) =>
//       variantsIds.includes(variant.id)
//     );
//   }, [variantsData, variantsIds]);

//   console.log(filteredVariantsOption);

//   useEffect(() => {
//     filteredVariantsOption.forEach((variant) => {
//       variant.options.forEach((opt) => {
//         setValue(
//           `variants.${variant.id}.${opt.id}.options`,
//           opt.options
//         );
//       });
//     });
//   }, [filteredVariantsOption]);

//   // if (variantsLoading || categoryVariantsLoading) {
//   //   return <Spinner variant="primary" animation="border" />;
//   // }

//   return (
//     <>
//       {variantsLoading || categoryVariantsLoading ? (
//         <div className="d-flex py-3 justify-content-center align-items-center">
//           <Button variant="falcon-default" size="sm" className="fs-10">
//             Loading...
//           </Button>
//         </div>
//       ) : (
//         <Row className="gx-2">
//           {filteredVariantsOption.map((data, index) => (
//             <Row key={index}>
//               <Card.Header as="h6" className="bg-body-tertiary text-800 ">
//                 {data.name}
//               </Card.Header>
//               <div className="mb-3">
//                 <Card.Body className="" style={{ padding: "0px" }}>
//                   <Row className=" my-1">
//                     <Table responsive>
//                       <thead className="bg-200">
//                         <tr>
//                           <th scope="col" className="fs-10">
//                             Name
//                           </th>
//                           <th scope="col" className="fs-10">
//                             Options
//                           </th>
//                           <th scope="col" className="fs-10">
//                             Images
//                           </th>
//                           <th scope="col"></th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {data?.options?.map((item, index) => (
//                           <tr key={index}>
//                             <td style={{ padding: "5px", width: "30%" }}>
//                               <Form.Control
//                                 type="text"
//                                 placeholder="Name"
//                                 value={item.name}
//                                 disabled
//                               />
//                             </td>
//                             {/* <td style={{ width: "30%", padding: "5px" }}>
//                               <div className="form-control d-flex flex-wrap align-items-center">
//                                 {item?.options?.map((tag, tagIndex) => (
//                                   <SubtleBadge
//                                     key={tagIndex}
//                                     className="mr-2 mb-1 mx-1"
//                                   >
//                                     {tag}
//                                     <span
//                                       className="ml-2"
//                                       style={{ cursor: "pointer" }}
//                                     >
//                                       &times;
//                                     </span>
//                                   </SubtleBadge>
//                                 ))}
//                               </div>
//                             </td> */}
//                             <td style={{ width: "30%", padding: "5px" }}>
//                               <Select
//                                 isMulti
//                                 isClearable
//                                 closeMenuOnSelect={false}
//                                 options={selectOptions}
//                                 placeholder="Select options"

//                                 value={selectOptions.filter(opt =>
//                                   selectedOptions.includes(opt.value)
//                                 )}

//                                 onChange={(selected) => {
//                                   const values = selected ? selected.map(s => s.value) : [];

//                                   setValue(
//                                     `variants.${data.id}.${item.id}.options`,
//                                     values,
//                                     { shouldDirty: true }
//                                   );
//                                 }}
//                               />

//                             </td>

//                             <td style={{ width: "30%", padding: "5px" }}>

//                               <LightBoxLatestExample
//                                 images={
//                                   item?.images?.map(
//                                     (image) =>
//                                       `data:image/${image?.fileName
//                                         ?.split(".")
//                                         .pop()};base64,${image?.fileBase64}`
//                                   ) || []
//                                 }
//                               >
//                                 {(setImgIndex) => (
//                                   <Row className="g-2">
//                                     {item?.images?.map((image, imgIndex) => (
//                                       <Col
//                                         xs={6}
//                                         md={4}
//                                         lg={3}
//                                         key={imgIndex}
//                                         className="position-relative"
//                                       >
//                                         <div className="d-flex gap-2 align-items-center">
//                                           <img
//                                             src={`data:image/${image?.fileName
//                                               ?.split(".")
//                                               .pop()};base64,${image?.fileBase64
//                                               }`}
//                                             width="100%"
//                                             style={{
//                                               display: "block",
//                                               borderRadius: "8px",
//                                               cursor: "pointer",
//                                             }}
//                                             onClick={() =>
//                                               setImgIndex(imgIndex)
//                                             } // Open lightbox with selected image
//                                           />
//                                         </div>
//                                       </Col>
//                                     ))}
//                                   </Row>
//                                 )}
//                               </LightBoxLatestExample>

//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   </Row>
//                 </Card.Body>
//               </div>
//             </Row>
//           ))}
//         </Row>
//       )}
//     </>
//   );
// };

// export default Variants;

// import LightBoxLatestExample from "components/common/LightBoxLatestExample";
// import { useFetchCategoryVariants } from "hooks/useFetchCategoryVariants";
// import { useFetchVariants } from "hooks/useFetchDetailVariants";
// import { useEffect, useMemo } from "react";
// import {
//   Button,
//   Card,
//   Col,
//   Form,
//   Row,
//   Table
// } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import { useLocation, useNavigate } from "react-router-dom";
// import Select from "react-select";

// const Variants = () => {
//   const {
//     watch,
//     setValue
//   } = useFormContext();

//   const { pathname } = useLocation();
//   const navigate = useNavigate();

//   const categoryId = watch("categoryId");

//   const { data: variantsData, isLoading: variantsLoading } =
//     useFetchVariants();

//   const { data: categoryVariantsData, isLoading: categoryVariantsLoading } =
//     useFetchCategoryVariants();

//   /* ----------------------------------
//      FILTER CATEGORY VARIANTS
//   ---------------------------------- */
//   const filteredCategoryVariants = useMemo(() => {
//     if (!categoryVariantsData || !categoryId) return [];
//     return categoryVariantsData?.data?.data?.filter(
//       (set) => set.categoryId === categoryId
//     );
//   }, [categoryVariantsData, categoryId]);

//   /* ----------------------------------
//      GET VARIANT IDS
//   ---------------------------------- */
//   const variantsIds = useMemo(() => {
//     return filteredCategoryVariants.flatMap((set) =>
//       set.options.map((opt) => opt.variantId)
//     );
//   }, [filteredCategoryVariants]);

//   /* ----------------------------------
//      FILTER VARIANTS
//   ---------------------------------- */
//   const filteredVariantsOption = useMemo(() => {
//     if (!variantsData || variantsIds.length === 0) return [];
//     return variantsData?.data?.data?.filter((variant) =>
//       variantsIds.includes(variant.id)
//     );
//   }, [variantsData, variantsIds]);

//   /* ----------------------------------
//      INITIALIZE FORM VALUES
//   ---------------------------------- */
//   useEffect(() => {
//     filteredVariantsOption.forEach((variant) => {
//       variant.options.forEach((opt) => {
//         setValue(
//           `variants.${variant.id}.${opt.name}.options`,
//           opt.options || []
//         );
//       });
//     });
//   }, [filteredVariantsOption, setValue]);

//   /* ----------------------------------
//      LOADING STATE
//   ---------------------------------- */
//   if (variantsLoading || categoryVariantsLoading) {
//     return (
//       <div className="d-flex py-3 justify-content-center align-items-center">
//         <Button variant="falcon-default" size="sm">
//           Loading...
//         </Button>
//       </div>
//     );
//   }

//   return (
//     <Row className="gx-2">
//       {filteredVariantsOption.map((variant) => (
//         <Row key={variant.id} className="mb-3">
//           <Card.Header as="h6" className="bg-body-tertiary text-800">
//             {variant.name}
//           </Card.Header>

//           <Card.Body style={{ padding: 0 }}>
//             <Table responsive>
//               <thead className="bg-200">
//                 <tr>
//                   <th className="fs-10" style={{ width: "30%" }}>
//                     Name
//                   </th>
//                   <th className="fs-10" style={{ width: "30%" }}>
//                     Options
//                   </th>
//                   <th className="fs-10" style={{ width: "30%" }}>
//                     Images
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {variant.options.map((item, index) => {
//                   const fieldName = `variants.${variant.id}.${item.name}.options`;

//                   const selectedValues = watch(fieldName) || [];

//                   const selectOptions =
//                     item.options?.map((opt) => ({
//                       label: opt,
//                       value: opt
//                     })) || [];

//                   return (
//                     <tr key={index}>
//                       {/* NAME */}
//                       <td style={{ padding: "5px" }}>
//                         <Form.Control
//                           value={item.name}
//                           disabled
//                         />
//                       </td>

//                       {/* MULTI SELECT */}
//                       <td style={{ padding: "5px" }}>
//                         <Select
//                           isMulti
//                           isClearable
//                           closeMenuOnSelect={false}
//                           placeholder="Select options"
//                           options={selectOptions}
//                           value={selectOptions.filter((opt) =>
//                             selectedValues.includes(opt.value)
//                           )}
//                           onChange={(selected) => {
//                             const values = selected
//                               ? selected.map((s) => s.value)
//                               : [];

//                             setValue(fieldName, values, {
//                               shouldDirty: true
//                             });
//                           }}
//                         />
//                       </td>

//                       {/* IMAGES */}
//                       <td style={{ padding: "5px" }}>
//                         <LightBoxLatestExample
//                           images={
//                             item?.images?.map(
//                               (image) =>
//                                 `data:image/${image?.fileName
//                                   ?.split(".")
//                                   .pop()};base64,${image?.fileBase64}`
//                             ) || []
//                           }
//                         >
//                           {(setImgIndex) => (
//                             <Row className="g-2">
//                               {item?.images?.map((image, imgIndex) => (
//                                 <Col
//                                   xs={6}
//                                   md={4}
//                                   lg={3}
//                                   key={imgIndex}
//                                 >
//                                   <img
//                                     src={`data:image/${image?.fileName
//                                       ?.split(".")
//                                       .pop()};base64,${image?.fileBase64}`}
//                                     width="100%"
//                                     style={{
//                                       borderRadius: "8px",
//                                       cursor: "pointer"
//                                     }}
//                                     onClick={() =>
//                                       setImgIndex(imgIndex)
//                                     }
//                                   />
//                                 </Col>
//                               ))}
//                             </Row>
//                           )}
//                         </LightBoxLatestExample>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </Table>
//           </Card.Body>
//         </Row>
//       ))}
//     </Row>
//   );
// };

// export default Variants;

// import LightBoxLatestExample from "components/common/LightBoxLatestExample";
// import { useFetchCategoryVariants } from "hooks/useFetchCategoryVariants";
// import { useFetchVariants } from "hooks/useFetchDetailVariants";
// import { useEffect, useMemo } from "react";
// import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import Select from "react-select";

// const Variants = () => {
//   const { watch, setValue } = useFormContext();
//   const categoryId = watch("categoryId");

//   const { data: variantsData, isLoading: variantsLoading } = useFetchVariants();
//   const { data: categoryVariantsData, isLoading: categoryVariantsLoading } = useFetchCategoryVariants();

//   // Filter category variants
//   const filteredCategoryVariants = useMemo(() => {
//     if (!categoryVariantsData || !categoryId) return [];
//     return categoryVariantsData?.data?.data?.filter(
//       (set) => set.categoryId === categoryId
//     );
//   }, [categoryVariantsData, categoryId]);

//   // Get variant IDs
//   const variantsIds = useMemo(() => {
//     return filteredCategoryVariants.flatMap((set) =>
//       set.options.map((opt) => opt.variantId)
//     );
//   }, [filteredCategoryVariants]);

//   // Filter variants
//   const filteredVariantsOption = useMemo(() => {
//     if (!variantsData || variantsIds.length === 0) return [];
//     return variantsData?.data?.data?.filter((variant) =>
//       variantsIds.includes(variant.id)
//     );
//   }, [variantsData, variantsIds]);

//   // Initialize form values exactly like API structure
//   useEffect(() => {
//     const initialVariants = {};

//     filteredVariantsOption.forEach((variant) => {
//       initialVariants[variant.id] = {
//         ...variant,
//         options: variant.options.map((opt) => ({
//           ...opt,
//           options: opt.options || []
//         }))
//       };
//     });

//     setValue("variants", initialVariants);
//   }, [filteredVariantsOption, setValue]);

//   if (variantsLoading || categoryVariantsLoading) {
//     return (
//       <div className="d-flex py-3 justify-content-center align-items-center">
//         <Button variant="falcon-default" size="sm">Loading...</Button>
//       </div>
//     );
//   }

//   return (
//     <Row className="gx-2">
//       {filteredVariantsOption.map((variant) => (
//         <Row key={variant.id} className="mb-3">
//           <Card.Header as="h6" className="bg-body-tertiary text-800">
//             {variant.name}
//           </Card.Header>

//           <Card.Body style={{ padding: 0 }}>
//             <Table responsive>
//               <thead className="bg-200">
//                 <tr>
//                   <th className="fs-10" style={{ width: "30%" }}>Name</th>
//                   <th className="fs-10" style={{ width: "30%" }}>Options</th>
//                   <th className="fs-10" style={{ width: "30%" }}>Images</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {variant.options.map((item, index) => {
//                   const fieldName = `variants.${variant.id}.options.${index}.options`;
//                   const selectedValues = watch(fieldName) || [];

//                   const selectOptions = item.options.map(opt => ({ label: opt, value: opt }));

//                   return (
//                     <tr key={index}>
//                       {/* Name */}
//                       <td style={{ padding: "5px" }}>
//                         <Form.Control value={item.name} disabled />
//                       </td>

//                       {/* Multi Select */}
//                       <td style={{ padding: "5px" }}>
//                         <Select
//                           isMulti
//                           isClearable
//                           closeMenuOnSelect={false}
//                           placeholder="Select options"
//                           options={selectOptions}
//                           value={selectOptions.filter(opt => selectedValues.includes(opt.value))}
//                           onChange={(selected) => {
//                             const values = selected ? selected.map(s => s.value) : [];
//                             setValue(fieldName, values, { shouldDirty: true });
//                           }}
//                         />
//                       </td>

//                       {/* Images */}
//                       <td style={{ padding: "5px" }}>
//                         <LightBoxLatestExample
//                           images={item.optionImages?.filter(Boolean) || []}
//                         >
//                           {(setImgIndex) => (
//                             <Row className="g-2">
//                               {item.optionImages?.filter(Boolean).map((img, imgIndex) => (
//                                 <Col xs={6} md={4} lg={3} key={imgIndex}>
//                                   <img
//                                     src={img}
//                                     width="100%"
//                                     style={{ borderRadius: "8px", cursor: "pointer" }}
//                                     onClick={() => setImgIndex(imgIndex)}
//                                   />
//                                 </Col>
//                               ))}
//                             </Row>
//                           )}
//                         </LightBoxLatestExample>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </Table>
//           </Card.Body>
//         </Row>
//       ))}
//     </Row>
//   );
// };

// export default Variants;

// import LightBoxLatestExample from "components/common/LightBoxLatestExample";
// import { useFetchCategoryVariants } from "hooks/useFetchCategoryVariants";
// import { useFetchVariants } from "hooks/useFetchDetailVariants";
// import { useEffect, useMemo } from "react";
// import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import Select from "react-select";
// import { BASEURL } from "../../../../utils/customConfig";
// import { useLocation } from "react-router-dom";
// import { mapApiVariantsToUI } from "../../../../utils/functions";
// import Swal from "sweetalert2";

// const Variants = () => {
//   const location = useLocation()
//   const { watch, setValue } = useFormContext();
//   const categoryId = watch("categoryId");

//   const { data: variantsData, isLoading: variantsLoading } = useFetchVariants();
//   const { data: categoryVariantsData, isLoading: categoryVariantsLoading } = useFetchCategoryVariants();

//   // Filter category variants
//   const filteredCategoryVariants = useMemo(() => {
//     if (!categoryVariantsData || !categoryId) return [];
//     return categoryVariantsData?.data?.data?.filter(
//       (set) => set.categoryId === categoryId
//     );
//   }, [categoryVariantsData, categoryId]);

//   // Get variant IDs
//   const variantsIds = useMemo(() => {
//     return filteredCategoryVariants.flatMap((set) =>
//       set.options.map((opt) => opt.variantId)
//     );
//   }, [filteredCategoryVariants]);

//   // Filter variants
//   const filteredVariantsOption = useMemo(() => {
//     if (!variantsData || variantsIds.length === 0) return [];
//     return variantsData?.data?.data?.filter((variant) =>
//       variantsIds.includes(variant.id)
//     );
//   }, [variantsData, variantsIds]);

//   const handleGenerate = () => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "This will update pricing and stock. All previous records will be overwritten.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, update",
//       cancelButtonText: "Cancel"
//     }).then((result) => {
//       if (result.isConfirmed) {
//         // trigger regeneration
//         setValue("generatePermutations", Date.now());
//       }
//     });
//   };

//   console.log("filteredVariantsOption", filteredVariantsOption)

//   // // Initialize form values as array
//   // useEffect(() => {
//   //   const initialVariants = filteredVariantsOption.map((variant) => ({
//   //     ...variant,
//   //     options: variant.options.map((opt) => ({
//   //       ...opt,
//   //       allOptions: opt.options || [], // store original options here
//   //       options: [], // selected values start empty
//   //     })),
//   //   }));

//   //   setValue("productVariants", initialVariants);
//   // }, [filteredVariantsOption, setValue]);

//   // useEffect(() => {

//   //   if (location?.state?.productVariants.length < 0 && filteredVariantsOption.length > 0) {

//   //   }

//   //   // 🟢 EDIT MODE → use location.state
//   //   if (location.state?.productVariants) {
//   //     const mapped = mapApiVariantsToUI(location.state.productVariants);
//   //     setValue("productVariants", mapped);
//   //     return; // ⛔ stop here, DO NOT overwrite
//   //   }

//   //   // 🟡 CREATE MODE → build from variants API
//   //   if (!filteredVariantsOption.length) return;

//   //   const initialVariants = [
//   //     {
//   //       name: "Variant One",
//   //       sortOrder: 0,
//   //       status: true,
//   //       options: filteredVariantsOption.flatMap((variant) =>
//   //         variant.options.map((opt) => ({
//   //           ...opt,
//   //           allOptions: opt.options || [],
//   //           options: [], // selected empty
//   //         }))
//   //       )
//   //     }
//   //   ];

//   //   setValue("productVariants", initialVariants);
//   // }, [location.state, filteredVariantsOption, setValue]);

//   // useEffect(() => {
//   //   // 🟢 EDIT MODE → state has variants
//   //   if (location.state?.productVariants?.length > 0) {
//   //     const mapped = mapApiVariantsToUI(location.state.productVariants);
//   //     setValue("productVariants", mapped);
//   //     return; // stop here
//   //   }

//   //   // 🟢 EDIT MODE → state exists but empty, filteredVariantsOption available
//   //   if (
//   //     location.state?.productVariants?.length === 0 &&
//   //     filteredVariantsOption.length > 0
//   //   ) {
//   //     const initialVariants = [
//   //       {
//   //         name: "Variant One",
//   //         sortOrder: 0,
//   //         status: true,
//   //         options: filteredVariantsOption.flatMap((variant) =>
//   //           variant.options.map((opt) => ({
//   //             ...opt,
//   //             allOptions: opt.options || [],
//   //             options: [], // empty selection
//   //           }))
//   //         )
//   //       }
//   //     ];

//   //     setValue("productVariants", initialVariants);
//   //     return; // stop here
//   //   }

//   //   // 🟡 CREATE MODE → build from filteredVariantsOption
//   //   if (filteredVariantsOption.length > 0) {
//   //     const initialVariants = [
//   //       {
//   //         name: "Variant One",
//   //         sortOrder: 0,
//   //         status: true,
//   //         options: filteredVariantsOption.flatMap((variant) =>
//   //           variant.options.map((opt) => ({
//   //             ...opt,
//   //             allOptions: opt.options || [],
//   //             options: [], // empty selection
//   //           }))
//   //         )
//   //       }
//   //     ];

//   //     setValue("productVariants", initialVariants);
//   //     return; // stop here
//   //   }

//   //   // 🟠 No variants → clear form
//   //   setValue("productVariants", []);
//   // }, [location.state, filteredVariantsOption, setValue]);

//   useEffect(() => {
//     if (!filteredVariantsOption.length) {
//       setValue("productVariants", []);
//       return;
//     }

//     const savedSelections = location.state?.productVariants
//       ? mapApiVariantsToUI(location.state.productVariants)
//       : {};

//     const initialVariants = [
//       {
//         name: "Variant One",
//         sortOrder: 0,
//         status: true,
//         options: filteredVariantsOption.flatMap((variant) =>
//           variant.options.map((opt) => ({
//             variantId: opt.id,
//             name: opt.name,
//             allOptions: opt.options || [],
//             options: savedSelections[opt.name] || [],
//             optionImages: opt.optionImages || [],
//           }))
//         ),
//       },
//     ];

//     setValue("productVariants", initialVariants);
//   }, [filteredVariantsOption, location.state, setValue]);

//   const variants = watch("productVariants") || [];

//   console.log("variants", variants)

//   if (variantsLoading || categoryVariantsLoading) {
//     return (
//       <div className="d-flex py-3 justify-content-center align-items-center">
//         <Button variant="falcon-default" size="sm">
//           Loading...
//         </Button>
//       </div>
//     );
//   }

//   return (
//     <>
//       {variants?.length > 0 && <>
//         <div className="d-flex justify-content-end">

//           <Button
//             variant="primary"
//             className="mb-3 "
//             onClick={handleGenerate}
//           >
//             Update
//           </Button>
//         </div>
//       </>}
//       <div className="px-3">
//         {Array.isArray(variants) &&
//           variants.map((variant, variantIndex) => (
//             <Row key={variant.id} className="mb-3">
//               {/* <Card.Header as="h6" className="bg-body-tertiary text-800">
//               {variant.name}
//             </Card.Header> */}

//               <Card.Body style={{ padding: 0 }}>
//                 <Table responsive>
//                   <thead className="bg-200">
//                     <tr>
//                       <th className="fs-10" style={{ width: "30%" }}>
//                         Name
//                       </th>
//                       <th className="fs-10" style={{ width: "30%" }}>
//                         Options
//                       </th>
//                       <th className="fs-10" style={{ width: "30%" }}>
//                         Images
//                       </th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {variant.options.map((item, optionIndex) => {
//                       const fieldName = `productVariants.${variantIndex}.options.${optionIndex}.options`;
//                       console.log("filedName: ", fieldName)
//                       const selectedValues = watch(fieldName) || [];

//                       console.log(selectedValues)

//                       // Use allOptions for the dropdown
//                       const selectOptions = (item.allOptions || []).map(opt => ({ label: opt, value: opt }));

//                       return (
//                         <tr key={optionIndex}>
//                           <td style={{ padding: "5px" }}>
//                             <Form.Control value={item.name} disabled />
//                           </td>

//                           <td style={{ padding: "5px" }}>
//                             <Select
//                               isMulti
//                               isClearable
//                               closeMenuOnSelect={false}
//                               menuPlacement="auto"
//                               menuPortalTarget={document.body}
//                               placeholder="Select options"
//                               options={selectOptions}  // always full list
//                               value={selectOptions.filter(opt => selectedValues.includes(opt.value))}
//                               onChange={(selected) => {
//                                 const values = selected ? selected.map(s => s.value) : [];
//                                 setValue(fieldName, values, { shouldDirty: true });
//                               }}
//                             />
//                           </td>

//                           <td style={{ padding: "5px" }}>
//                             <LightBoxLatestExample images={item.optionImages?.filter(Boolean).map((m) => BASEURL +
//                               "/wwwroot" + m) || []}>
//                               {(setImgIndex) => (
//                                 <Row className="g-2">
//                                   {item.optionImages?.filter(Boolean).map((img, imgIndex) => (
//                                     <Col xs={6} md={4} lg={1} key={imgIndex}>
//                                       <img
//                                         src={BASEURL + "/wwwroot" + img}
//                                         width="100%"
//                                         // height={50}
//                                         className="pr-2"
//                                         style={{ borderRadius: "8px", cursor: "pointer" }}
//                                         onClick={() => setImgIndex(imgIndex)}
//                                       />
//                                     </Col>
//                                   ))}
//                                 </Row>
//                               )}
//                             </LightBoxLatestExample>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>

//                 </Table>
//               </Card.Body>
//             </Row>
//           ))}
//       </div>
//     </>
//   );
// };

// export default Variants;

// import LightBoxLatestExample from "components/common/LightBoxLatestExample";
// import { useFetchCategoryVariants } from "hooks/useFetchCategoryVariants";
// import { useFetchVariants } from "hooks/useFetchDetailVariants";
// import { useEffect, useMemo, useRef } from "react";
// import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import Select from "react-select";
// import { BASEURL } from "../../../../utils/customConfig";
// import { useLocation } from "react-router-dom";
// import { mapApiVariantsToUI } from "../../../../utils/functions";
// import Swal from "sweetalert2";
// import { MdOutlineLibraryAddCheck } from "react-icons/md";
// import OverLayButton from "components/common/OverLayButton";
// const Variants = () => {
//   const location = useLocation();
//   const { watch, setValue } = useFormContext();
//   const categoryId = watch("categoryId");

//   const { data: variantsData, isLoading: variantsLoading } = useFetchVariants();
//   const { data: categoryVariantsData, isLoading: categoryVariantsLoading } =
//     useFetchCategoryVariants();

//   // Filter category variants
//   const filteredCategoryVariants = useMemo(() => {
//     if (!categoryVariantsData || !categoryId) return [];
//     return categoryVariantsData?.data?.data?.filter(
//       (set) => set.categoryId === categoryId,
//     );
//   }, [categoryVariantsData, categoryId]);

//   // Get variant IDs
//   const variantsIds = useMemo(() => {
//     return filteredCategoryVariants.flatMap((set) =>
//       set.options.map((opt) => opt.variantId),
//     );
//   }, [filteredCategoryVariants]);

//   // Filter variants
//   const filteredVariantsOption = useMemo(() => {
//     if (!variantsData || variantsIds.length === 0) return [];
//     return variantsData?.data?.data?.filter((variant) =>
//       variantsIds.includes(variant.id),
//     );
//   }, [variantsData, variantsIds]);

//   const handleGenerate = () => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "This will update pricing and stock. All previous records will be overwritten.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, update",
//       cancelButtonText: "Cancel",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         // trigger regeneration
//         setValue("generatePermutations", Date.now());
//       }
//     });
//   };

//   console.log("filteredVariantsOption", filteredVariantsOption);

//   const initializedRef = useRef(false);

//   useEffect(() => {
//     if (initializedRef.current) return;

//     if (!filteredVariantsOption.length) return;

//     const savedSelections = location.state?.productVariants
//       ? mapApiVariantsToUI(location.state.productVariants)
//       : {};

//     const initialVariants = [
//       {
//         name: "Variant One",
//         sortOrder: 0,
//         status: true,
//         options: filteredVariantsOption.flatMap((variant) =>
//           variant.options.map((opt) => ({
//             variantId: opt.id,
//             name: opt.name,
//             allOptions: opt.options || [],
//             options: savedSelections[opt.name] || [],
//             optionImages: opt.optionImages || [],
//           })),
//         ),
//       },
//     ];

//     setValue("productVariants", initialVariants);
//     initializedRef.current = true;
//   }, [filteredVariantsOption, setValue]);

//   // useEffect(() => {
//   //   if (!filteredVariantsOption.length) {
//   //     setValue("productVariants", []);
//   //     return;
//   //   }

//   //   const savedSelections = location.state?.productVariants
//   //     ? mapApiVariantsToUI(location.state.productVariants)
//   //     : {};

//   //   const initialVariants = [
//   //     {
//   //       name: "Variant One",
//   //       sortOrder: 0,
//   //       status: true,
//   //       options: filteredVariantsOption.flatMap((variant) =>
//   //         variant.options.map((opt) => ({
//   //           variantId: opt.id,
//   //           name: opt.name,
//   //           allOptions: opt.options || [],
//   //           options: savedSelections[opt.name] || [],
//   //           optionImages: opt.optionImages || [],
//   //         }))
//   //       ),
//   //     },
//   //   ];

//   //   setValue("productVariants", initialVariants);
//   // }, [filteredVariantsOption, location.state, setValue]);

//   const variants = watch("productVariants") || [];

//   console.log("variants", variants);

//   if (variantsLoading || categoryVariantsLoading) {
//     return (
//       <div className="d-flex py-3 justify-content-center align-items-center">
//         <Button variant="falcon-default" size="sm">
//           Loading...
//         </Button>
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* {variants?.length > 0 && <>
//         <div className="d-flex justify-content-end">

//           <Button
//             variant="primary"
//             className="mb-3 "
//             onClick={handleGenerate}
//           >
//             Update
//           </Button>
//         </div>
//       </>} */}
//       <div className="px-3">
//         {Array.isArray(variants) &&
//           variants.map((variant, variantIndex) => (
//             <Row key={variant.id} className="mb-3">
//               {/* <Card.Header as="h6" className="bg-body-tertiary text-800">
//               {variant.name}
//             </Card.Header> */}

//               <Card.Body style={{ padding: 0 }}>
//                 <Table>
//                   <thead className="bg-200">
//                     <tr>
//                       <th className="fs-10" style={{ width: "30%" }}>
//                         Name
//                       </th>
//                       <th className="fs-10" style={{ width: "30%" }}>
//                         Options
//                       </th>
//                       <th className="fs-10" style={{ width: "5%" }}></th>
//                       <th className="fs-10" style={{ width: "30%" }}>
//                         Images
//                       </th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {variant.options.map((item, optionIndex) => {
//                       const fieldName = `productVariants.${variantIndex}.options.${optionIndex}.options`;
//                       console.log("filedName: ", fieldName);
//                       const selectedValues = watch(fieldName) || [];

//                       console.log(selectedValues);

//                       // Use allOptions for the dropdown
//                       const selectOptions = (item.allOptions || []).map(
//                         (opt) => ({ label: opt, value: opt }),
//                       );

//                       return (
//                         <tr key={optionIndex}>
//                           <td style={{ padding: "1px" }}>
//                             <Form.Control
//                               className="fs-10 py-2"
//                               value={item.name}
//                               disabled
//                             />
//                           </td>

//                           <td style={{ padding: "1px" }}>
//                             <Select
//                               isMulti
//                               isClearable
//                               closeMenuOnSelect={false}
//                               menuPlacement="auto"
//                               menuPortalTarget={document.body}
//                               placeholder="Select options"
//                               options={selectOptions} // always full list
//                               value={selectOptions.filter((opt) =>
//                                 selectedValues.includes(opt.value),
//                               )}
//                               onChange={(selected) => {
//                                 const values = selected
//                                   ? selected.map((s) => s.value)
//                                   : [];
//                                 setValue(fieldName, values, {
//                                   shouldDirty: true,
//                                 });
//                               }}
//                               styles={{
//                                 control: (base) => ({
//                                   ...base,
//                                   fontSize: "13px", // input text
//                                 }),
//                                 option: (base) => ({
//                                   ...base,
//                                   fontSize: "13px", // dropdown options
//                                 }),
//                                 multiValueLabel: (base) => ({
//                                   ...base,
//                                   fontSize: "13px", // selected chips text
//                                 }),
//                                 placeholder: (base) => ({
//                                   ...base,
//                                   fontSize: "13px",
//                                 }),
//                                 singleValue: (base) => ({
//                                   ...base,
//                                   fontSize: "13px",
//                                 }),
//                               }}
//                             />
//                           </td>
//                           <td style={{ padding: "1px" }}>
//                             <OverLayButton
//                               toolTip="Update Pricing and Stock"
//                               icon={<MdOutlineLibraryAddCheck />}
//                               onClick={handleGenerate}
//                             />
//                           </td>
//                           <td style={{ padding: "1px" }}>
//                             <LightBoxLatestExample
//                               images={
//                                 item.optionImages
//                                   ?.filter(Boolean)
//                                   .map((m) => BASEURL + "/wwwroot" + m) || []
//                               }
//                             >
//                               {(setImgIndex) => (
//                                 <Row className="g-2">
//                                   {item.optionImages
//                                     ?.filter(Boolean)
//                                     .map((img, imgIndex) => (
//                                       <Col xs={6} md={4} lg={1} key={imgIndex}>
//                                         <img
//                                           src={BASEURL + "/wwwroot" + img}
//                                           width="100%"
//                                           // height={50}
//                                           className="pr-2"
//                                           style={{
//                                             borderRadius: "8px",
//                                             cursor: "pointer",
//                                           }}
//                                           onClick={() => setImgIndex(imgIndex)}
//                                         />
//                                       </Col>
//                                     ))}
//                                 </Row>
//                               )}
//                             </LightBoxLatestExample>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </Card.Body>
//             </Row>
//           ))}
//       </div>
//     </>
//   );
// };

// export default Variants;

import LightBoxLatestExample from "components/common/LightBoxLatestExample";
import { useFetchCategoryVariants } from "hooks/useFetchCategoryVariants";
import { useFetchVariants } from "hooks/useFetchDetailVariants";
import { useEffect, useMemo, useRef } from "react";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import Select from "react-select";
import { BASEURL } from "../../../../utils/customConfig";
import { useLocation } from "react-router-dom";
import { mapApiVariantsToUI } from "../../../../utils/functions";
import Swal from "sweetalert2";
import { MdOutlineLibraryAddCheck } from "react-icons/md";
import OverLayButton from "components/common/OverLayButton";
import SortableSelect from "./utils/SortableSelect";

import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function SortableChip({ id }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: "4px 10px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    background: "#f8f9fa",
    cursor: "grab",
    fontSize: "12px",
  };

  return (
    <span ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {id}
    </span>
  );
}

function SortableChips({ values, onChange }) {
  return (
    <DndContext
      collisionDetection={closestCenter}
      onDragEnd={(event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        const oldIndex = values.indexOf(active.id);
        const newIndex = values.indexOf(over.id);

        const newOrder = arrayMove(values, oldIndex, newIndex);
        onChange(newOrder);
      }}
    >
      <SortableContext items={values} strategy={horizontalListSortingStrategy}>
        <div
          style={{
            display: "flex",
            gap: "6px",
            marginTop: "6px",
            flexWrap: "wrap",
          }}
        >
          {values.map((val) => (
            <SortableChip key={val} id={val} />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
}

const Variants = () => {
  const location = useLocation();
  const {
    watch,
    setValue,
    formState: { errors },
    register,
  } = useFormContext();
  const categoryId = watch("categoryId");

  const { data: variantsData, isLoading: variantsLoading } = useFetchVariants();
  const { data: categoryVariantsData, isLoading: categoryVariantsLoading } =
    useFetchCategoryVariants();

  // Filter category variants
  const filteredCategoryVariants = useMemo(() => {
    if (!categoryVariantsData || !categoryId) return [];
    return categoryVariantsData?.data?.data
      ?.filter((cvd) => cvd.status)
      ?.filter((set) => set.categoryId === categoryId);
  }, [categoryVariantsData, categoryId]);

  // Get variant IDs
  const variantsIds = useMemo(() => {
    return filteredCategoryVariants.flatMap((set) =>
      set.options.map((opt) => opt.variantId),
    );
  }, [filteredCategoryVariants]);

  // Filter variants
  const filteredVariantsOption = useMemo(() => {
    if (!variantsData || variantsIds.length === 0) return [];
    return variantsData?.data?.data
      ?.filter((vd) => vd.status)
      ?.filter((variant) => variantsIds.includes(variant.id));
  }, [variantsData, variantsIds]);

  console.log("{filteredVariantsOption}", filteredVariantsOption);

  const handleGenerate = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will update pricing and stock. All previous records will be overwritten.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // trigger regeneration
        setValue("generatePermutations", Date.now());
      }
    });
  };

  // console.log("filteredVariantsOption", filteredVariantsOption);

  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;

    if (!filteredVariantsOption.length) return;

    const savedSelections = location.state?.productVariants
      ? mapApiVariantsToUI(location.state.productVariants)
      : {};

    const initialVariants = [
      {
        name: "Variant One",
        sortOrder: 0,
        status: true,
        options: filteredVariantsOption.flatMap((variant) =>
          variant.options.map((opt) => ({
            variantId: opt.id,
            name: opt.name,
            allOptions: opt.options || [],
            options: savedSelections[opt.name]?.options || [],
            // showImage: savedSelections[opt.name]?.showImage ?? false,
            showImage:
              savedSelections[opt.name]?.showImage ?? opt.showImage ?? false,
            optionImages: opt.optionImages || [],

            oiMapping: opt.oiMapping || "",
          })),
        ),
      },
    ];

    // console.log("initialVariants", initialVariants);

    setValue("productVariants", initialVariants);
    initializedRef.current = true;
  }, [filteredVariantsOption, setValue]);

  // useEffect(() => {
  //   if (!filteredVariantsOption.length) {
  //     setValue("productVariants", []);
  //     return;
  //   }

  //   const savedSelections = location.state?.productVariants
  //     ? mapApiVariantsToUI(location.state.productVariants)
  //     : {};

  //   const initialVariants = [
  //     {
  //       name: "Variant One",
  //       sortOrder: 0,
  //       status: true,
  //       options: filteredVariantsOption.flatMap((variant) =>
  //         variant.options.map((opt) => ({
  //           variantId: opt.id,
  //           name: opt.name,
  //           allOptions: opt.options || [],
  //           options: savedSelections[opt.name] || [],
  //           optionImages: opt.optionImages || [],
  //         }))
  //       ),
  //     },
  //   ];

  //   setValue("productVariants", initialVariants);
  // }, [filteredVariantsOption, location.state, setValue]);

  const variants = watch("productVariants") || [];

  // console.log("variants", variants);

  const parseOiMapping = (mappingString) => {
    if (!mappingString) return {};

    return mappingString.split("|").reduce((acc, pair) => {
      const [key, value] = pair.split("=");
      if (key && value) {
        acc[key.trim()] = value.trim();
      }
      return acc;
    }, {});
  };

  if (variantsLoading || categoryVariantsLoading) {
    return (
      <div className="d-flex py-3 justify-content-center align-items-center">
        <Button variant="falcon-default" size="sm">
          Loading...
        </Button>
      </div>
    );
  }

  return (
    <>
      {/* {variants?.length > 0 && <>
        <div className="d-flex justify-content-end">

          <Button
            variant="primary"
            className="mb-3 "
            onClick={handleGenerate}
          >
            Update
          </Button>
        </div>
      </>} */}
      <div className="px-3">
        {Array.isArray(variants) &&
          variants.map((variant, variantIndex) => (
            <Row key={variant.id} className="mb-3">
              {/* <Card.Header as="h6" className="bg-body-tertiary text-800">
              {variant.name}
            </Card.Header> */}

              <Card.Body style={{ padding: 0 }}>
                <Table>
                  <thead className="bg-200">
                    <tr>
                      <th className="fs-10" style={{ width: "30%" }}>
                        Name
                      </th>
                      <th className="fs-10" style={{ width: "30%" }}>
                        Options
                      </th>
                      <th className="fs-10"></th>
                      <th className="fs-10 text-center" style={{ width: "7%" }}>
                        Show Image
                      </th>
                      <th className="fs-10" style={{ width: "30%" }}>
                        Images
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {variant.options.map((item, optionIndex) => {
                      const fieldName = `productVariants.${variantIndex}.options.${optionIndex}.options`;
                      const selectedValues = watch(fieldName) || [];

                      const selectOptions = (item.allOptions || []).map(
                        (opt) => ({
                          label: opt,
                          value: opt,
                        }),
                      );

                      const selectedObjects = selectedValues.map((val) =>
                        selectOptions.find((opt) => opt.value === val),
                      );

                      const mappingObj = parseOiMapping(item.oiMapping);
                      // console.log("mappingObj", mappingObj);

                      const mappedImages = selectedValues
                        .map((val) => mappingObj[val])
                        .filter(Boolean)
                        .map((img) => BASEURL + "/wwwroot" + img);

                      // console.log("item", item);

                      return (
                        <tr key={optionIndex}>
                          <td style={{ padding: "5px 0px" }}>
                            <Form.Control
                              className="fs-10 py-2"
                              value={item.name}
                              disabled
                            />
                          </td>

                          <td style={{ padding: "5px 5px" }}>
                            <SortableSelect
                              options={selectOptions}
                              value={selectedObjects}
                              placeholder="Select options"
                              onChange={(newSelected, meta) => {
                                if (!newSelected) {
                                  setValue(fieldName, []);
                                  return;
                                }

                                const values = newSelected?.map(
                                  (s) => s?.value,
                                );

                                // ✅ prevent react-select reorder reset
                                setValue(fieldName, values, {
                                  shouldDirty: true,
                                  shouldTouch: true,
                                });
                              }}
                            />
                            {/* 🔥 Drag & Drop Selected Order */}
                            {/* {selectedValues.length > 0 && (
                              <SortableChips
                                values={selectedValues}
                                onChange={(newOrder) =>
                                  setValue(fieldName, newOrder, {
                                    shouldDirty: true,
                                  })
                                }
                              />
                            )} */}
                          </td>
                          <td style={{ padding: "5px 0px" }}>
                            <OverLayButton
                              toolTip="Update Pricing and Stock"
                              icon={<MdOutlineLibraryAddCheck />}
                              onClick={handleGenerate}
                            />
                          </td>

                          <td
                            style={{ padding: "5px" }}
                            className="text-center"
                          >
                            <Form.Check
                              type="checkbox"
                              id="defaultSwitch"
                              className="mt-1"
                              {...register(
                                `productVariants.${variantIndex}.options.${optionIndex}.showImage`,
                              )}
                              // def={item?.showImage}
                            />
                          </td>

                          <td style={{ padding: "5px 5px" }}>
                            <LightBoxLatestExample
                              images={mappedImages}
                              // images={
                              //   item.optionImages
                              //     ?.filter(Boolean)
                              //     .map((m) => BASEURL + "/wwwroot" + m) || []
                              // }
                            >
                              {(setImgIndex) => (
                                <Row className="g-2">
                                  {mappedImages?.map((img, imgIndex) => (
                                    <Col xs={6} md={4} lg={1} key={imgIndex}>
                                      <img
                                        src={img}
                                        width="100%"
                                        // height={50}
                                        className="pr-2"
                                        style={{
                                          borderRadius: "8px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => setImgIndex(imgIndex)}
                                      />
                                    </Col>
                                  ))}
                                </Row>
                              )}
                            </LightBoxLatestExample>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Row>
          ))}
      </div>
    </>
  );
};

export default Variants;
